import { menusGetApi, promptConfigGetApi } from '@/api/common';
import storage from '@/utils/storage';
import { defineStore } from 'pinia';
interface MenuDataType {
    id?: string | number;
    type?: string | number;
    name?: string;
    path?: string;
    icon?: string;
    parentId?: string | number;
    children?: MenuDataType[];
    permission?: string;
    code?: string;
}

interface DataType {
    menus: MenuDataType[];
    breadcrumbs?: Record<string, any>;
    urls?: Record<string, any>;
    codeTexts?: Record<string, any>;
}

export interface UserState {
    systemData: {
        prompts?: Record<string, any>;
        menus?: MenuDataType[];
        urls?: Record<string, any>;
        codeTexts?: Record<string, any>;
        routes?: any[];
    } | null;
}
/**
 * 解析服务端返回的数据
 * @param {MenuDataType[]} data 解析的数据
 * @returns {AsyncFunReturn}
 */
const parseData = (data: MenuDataType[]) => {
    // 菜单列表
    const menus: MenuDataType[] = [];
    // 路由列表
    const routes: any[] = [];
    // 重定向对象
    const redirects: Record<string, any> = {};
    // url对象
    const urls: Record<string, any> = {};
    // 文本对象
    const codeTexts: Record<string, any> = {};
    // 菜单ID映射对象
    const menuIds: Record<string, any> = {};

    const innerFn = (souces: MenuDataType[], _menus: MenuDataType[]) => {
        for (const item of souces) {
            const {
                id = '',
                type = '',
                icon = '',
                parentId = '',
                code = '',
                name = '',
                path = '',
                children = []
            } = item;
            const menu: MenuDataType = {
                id,
                name,
                path,
                icon,
                parentId,
                children: []
            };

            const route: Record<string, any> = {
                path,
                name,
                component: undefined,
                children: []
            };

            if (/^\//.test(path)) {
                menuIds[path] = id;
            }

            if (children.length) {
                const findItem = children.find((it) => Number(it.type) === 0);
                if (findItem) {
                    redirects[path] = findItem.path;
                }

                innerFn(children, menu.children as MenuDataType[]);
            }

            if (redirects[path]) {
                redirects[path] = redirects[redirects[path]] || redirects[path];
                routes.push({
                    name,
                    path,
                    exact: true,
                    redirect: redirects[path]
                });
            }

            if (route.component) {
                routes.push(route);
            }

            if (Number(type) === 0) {
                _menus.push(menu);
            }

            if (code) {
                if (/^\//.test(path)) {
                    urls[code] = path;
                }
                codeTexts[code] = name;
            }
        }
    };

    innerFn(data, menus);
    storage.set('menuIds', menuIds);

    return {
        menus,
        urls,
        codeTexts,
        routes
    };
};

// 用户信息全局状态
export const useSystemStore = defineStore({
    id: 'system',
    state: (): UserState => ({
        systemData: null
    }),
    getters: {
        getSystem: (state) => state.systemData
    },
    actions: {
        async initSystem() {
            try {
                const data = await Promise.all([promptConfigGetApi().send(true), menusGetApi('mobile').send(true)]);
                let prompts = {};
                (data[0] || []).forEach((item: any) => {
                    prompts = {
                        ...prompts,
                        [item.code]: item.promptText
                    };
                });
                const { menus, urls, codeTexts, routes } = parseData(data[1] || []);

                this.systemData = {
                    prompts,
                    menus,
                    urls,
                    codeTexts,
                    routes
                };
            } catch (error) {
                return error;
            }
        },
        updateUser(systemData: Record<string, any>) {
            this.systemData = { ...this.systemData, ...systemData };
        },
        deleteUser() {
            this.systemData = null;
        }
    },
    persist: true
});
